const whenCookieLevel4Accepted = require("./whenCookieLevel4Accepted");
const thenSetGlobalAppStartedFlag = require("./thenSetGlobalAppStartedFlag");
const thenListenForCookieLevel4Accepted = require("./thenListenForCookieLevel4Accepted");
const thenAppendIterableEmailIdInputToAllForms = require("./thenAppendIterableEmailIdInputToAllforms");
const listenForForm1262Submit = require("./run/form1262/listenForForm1262Submit");
const whenForm1262Submits = require("./when/form1262/whenForm1262Submits");
const initForm1262ReturningUserEmail = require("./run/form1262/initForm1262ReturningUserEmail");
const whenForm1262ReturningUserCtaClicked = require("./when/form1262/whenForm1262ReturningUserCtaClicked");
const listenForForm1262ReturningUserCtaClicks = require("./run/form1262/listenForForm1262ReturningUserCtaClicks");
const listenForForm1262ReturningUserNotYouClicks = require("./run/form1262/listenForForm1262ReturningUserNotYouClicks");
const whenForm1262ReturningUserNotYouButtonClicked = require("./when/form1262/whenForm1262ReturningUserNotYouButtonClicked");
const initForm1262ReturningUser = require("./run/form1262/initForm1262ReturningUser");
require("./run/form1262/Form1262_initAll");
/**
 * @param data {Data}
 * @returns {void}
 */
module.exports = function whenAppStarted(data) {
  thenListenForCookieLevel4Accepted(data, () => whenCookieLevel4Accepted(data));
  thenSetGlobalAppStartedFlag(data);
  thenAppendIterableEmailIdInputToAllForms(data);

  initForm1262ReturningUser();
  initForm1262ReturningUserEmail();
  listenForForm1262Submit((formId) => whenForm1262Submits(formId));
  listenForForm1262ReturningUserCtaClicks(() => whenForm1262ReturningUserCtaClicked());
  listenForForm1262ReturningUserNotYouClicks(() => whenForm1262ReturningUserNotYouButtonClicked());
};
